import React from 'react'
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
  Form,
  FormGroup,
} from 'reactstrap'
import Swal from "sweetalert2";

import { DataTable, MiniLoading } from "../../components/revel-strap"

import { ProductCategoryModel, ProductModel } from '../../models'

import { numberFunc } from "../../utils"

const product_model = new ProductModel()
const product_category_model = new ProductCategoryModel()

class ProductSearchModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      is_loading: false,
      pageSize: 20,
      product_code: '',
      product_name: '',
      supplier_code: '',
      product_price: '',
      product_barcode: '',
      products: [],
      product_categorys: [],
      product_lists: [],
    }
  }

  componentDidUpdate(props_old) {
    if (!props_old.show && this.props.show) {
      this.setState({
        product_code: '',
        product_name: '',
        supplier_code: '',
        product_price: '',
        product_barcode: '',
        products: [],
      })
    }
  }

  _fetchData = (params = { pagination: { current: 1, pageSize: 20 } }) => this.setState({ is_loading: true }, async () => {
    const { product_code, product_name, supplier_code, product_price, product_barcode } = this.state

    if (product_code === '' && product_name === '' && supplier_code === '' && product_price === '' && product_barcode === '') {
      this.setState({
        is_loading: false,
        products: [],
      })
    } else {
      if (product_code !== '' || product_name !== '' || supplier_code !== '' || product_price !== '' || product_barcode !== '') {
        if (product_code !== '' && product_code.length < 4) {
          Swal.fire({ text: "กรุณาระบุรหัสสินค้าขั้นต่ำ 4 ตัวอักษร !", icon: "warning" })
          this.setState({
            is_loading: false,
          })
        } else {
          params.pagination.pageSize = 500
          const products = await product_model.getProductByList({
            params,
            // product_child: 0,
            product_code: product_code,
            product_name: product_name,
            product_barcode: product_barcode,
            supplier_code: supplier_code,
            product_price: product_price
          })

          if (products?.data?.length) {
            const product_categorys = await product_category_model.getProductCategoryBy()
            this.setState({
              is_loading: false,
              products,
              product_categorys: product_categorys.data,
            })
          } else {
            this.setState({
              is_loading: false ,
              products: []
            }, () => {
              Swal.fire({
                title: 'ไม่พบสินค้าในระบบ !',
                icon: 'error',
              })
            })
          }

        }
      }
    }
  })

  _onSearchData = () => this.setState({ is_loading: true }, async () => {
    const { product_code, product_name, supplier_code, product_price, product_barcode } = this.state
    if (product_code === '' && product_name === '' && supplier_code === '' && product_price === '' && product_barcode === '') {
      this.setState({
        is_loading: false,
        products: [],
      })
    } else {
      if (product_code !== '' || product_name !== '' || supplier_code !== '' || product_price !== '' || product_barcode !== '') {
        if (product_code !== '' && product_code.length < 4) {
          Swal.fire({ text: "กรุณาระบุรหัสสินค้าขั้นต่ำ 4 ตัวอักษร !", icon: "warning" })
          this.setState({
            is_loading: false,
          })
        } else {
          const params = { pagination: { pageSize: 500 } }

          const products = await product_model.getProductByList({
            params,
            // product_child: 0,
            product_code: product_code,
            product_name: product_name,
            product_barcode: product_barcode,
            supplier_code: supplier_code,
            product_price: product_price
          })

          if (products.length) {
            const product_categorys = await product_category_model.getProductCategoryBy()
            this.setState({
              is_loading: false,
              products,
              product_categorys: product_categorys.data,
            })
          } else {
            this.setState({ is_loading: false }, () => {
              Swal.fire({
                title: 'ไม่พบสินค้าในระบบ !',
                icon: 'error',
              })
            })
          }

        }
      }
    }
  })

  _onConfirm = () => this.props.onSave(this.state.product_lists.map((item) => ({
    product_code: item.product_code,
    product_name: item.product_name,
    product_price: item.product_price,
    product_unit_name: item.product_unit_name,
    product_brand_name: item.product_brand_name,
    stock_cost_avg: item.stock_cost_avg,
  })))


  _handleClose = () => this.props.onClose()

  render() {
    return (
      <Modal size="xl" centered isOpen={this.props.show} toggle={this._handleClose}>
        <ModalHeader toggle={this._handleClose}>ค้นหาสินค้า</ModalHeader>
        <div className="ml-3 mt-2">
          <Row>
            <Form onSubmit={this._onSearchData}>
              <Col md={12} style={{ display: "flex" }}>
                <FormGroup
                  className="align-bottom d-inline-block"
                  style={{ marginRight: 8 }}>
                  <label>ชื่อสินค้า</label>
                  <Input
                    placeholder="ระบุชื่อสินค้า"
                    onChange={(e) => { this.setState({ product_name: e.target.value, pageSize: 500 }) }}
                    onKeyDown={(e) => e.key === 'Enter' && this._fetchData()}
                  />
                </FormGroup>
                <FormGroup
                  className="align-bottom d-inline-block"
                  style={{ marginRight: 8 }}>
                  <label>รหัสสินค้า</label>
                  <Input
                    placeholder="ระบุรหัสสินค้า"
                    onChange={(e) => { this.setState({ product_code: e.target.value, pageSize: 500 }) }}
                    onKeyDown={(e) => e.key === 'Enter' && this._fetchData()}
                  />
                </FormGroup>
                <FormGroup
                  className="align-bottom d-inline-block"
                  style={{ marginRight: 8 }}>
                  <div className="d-inline-block">
                    <label>ผู้ขาย </label>
                    <Input
                      placeholder="ระบุผู้ขาย"
                      onChange={(e) => { this.setState({ supplier_code: e.target.value, pageSize: 500 }) }}
                      onKeyDown={(e) => e.key === 'Enter' && this._fetchData()}
                    />
                  </div>
                </FormGroup>
                <FormGroup
                  className="align-bottom d-inline-block"
                  style={{ marginRight: 8 }}>
                  <div className="d-inline-block">
                    <label>ราคา </label>
                    <Input
                      placeholder="ราคา"
                      onChange={(e) => { this.setState({ product_price: e.target.value, pageSize: 500 }) }}
                    />
                  </div>
                </FormGroup>
                <FormGroup className="align-bottom d-inline-block" style={{ marginRight: 8, marginTop: 29 }}>
                  <button type="button" className="btn btn-primary" onClick={() => this._fetchData()}>ค้นหา</button>
                </FormGroup>
              </Col>
            </Form>
          </Row>
        </div>
        <ModalBody>
          {this.state.is_loading ? (
            <div className="text-center pt-4">
              <MiniLoading className="mx-auto" /> กำลังโหลดข้อมูล
            </div>
          ) : (
            <DataTable
              // ref={(e) => (this.data_table = e)}
              onChange={this._fetchData}
              showRowNo={true}
              dataSource={this.state.products.data}
              dataTotal={this.state.products.total}
              pageSize={this.state.pageSize}
              setProps={{
                rowSelection: {
                  type: "checkbox",
                  preserveSelectedRowKeys: true,
                  onChange: (selectedRowKeys, selectedRows) => this.setState({ product_lists: selectedRows, }),
                },
              }}
              rowKey="product_code"
              columns={[
                {
                  title: "รหัส",
                  dataIndex: "product_code",
                  filterAble: true,
                  sorter: true,
                  ellipsis: true,
                  width: 160,
                },
                {
                  title: "สินค้า",
                  dataIndex: "product_name",
                  filterAble: true,
                  sorter: true,
                  ellipsis: true,
                  width: 220,
                },
                {
                  title: "ราคาปลีก",
                  dataIndex: "product_price",
                  render: (cell) => {
                    return <span>{numberFunc.decimalFix(cell, 2)}</span>;
                  },
                  sorter: false,
                  align: "right",
                  width: 100,
                },
                {
                  title: "ราคาส่ง",
                  dataIndex: "product_scale_price",
                  render: (cell) => {
                    return <span>{numberFunc.decimalFix(cell, 2)}</span>;
                  },
                  sorter: false,
                  align: "right",
                  width: 100,
                },
                {
                  title: "ราคาทุน",
                  dataIndex: "stock_cost_avg",
                  render: (cell) => {
                    return <span>{numberFunc.decimalFix(cell, 2)}</span>;
                  },
                  sorter: false,
                  align: "right",
                  width: 100,
                },
                {
                  title: "ยี่ห้อ",
                  dataIndex: "product_brand_name",
                  filterAble: false,
                  ellipsis: true,
                  align: "center",
                  width: 140,
                },
                {
                  title: "แพ็ค",
                  dataIndex: "product_unit_name",
                  filterAble: false,
                  ellipsis: true,
                  align: "center",
                  width: 100,
                },
                {
                  title: "หมวดหมู่",
                  dataIndex: "product_category_code",
                  render: (cell, row, idx) => row.product_category_name,
                  filters: this.state.product_categorys.map((item) => ({
                    text: item.product_category_name,
                    value: item.product_category_code,
                  })),
                  ellipsis: true,
                  align: "center",
                  width: 180,
                },
              ]}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="success" onClick={this._onConfirm}>ยืนยัน</Button>
          <Button type="button" onClick={this._handleClose}>ยกเลิก</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ProductSearchModal